import { render } from "./Header.vue?vue&type=template&id=dd2cb906&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=dd2cb906&scoped=true&lang=css"

import exportComponent from "/home/runner/work/metal-client/metal-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2cb906"]])

export default __exports__